// extracted by mini-css-extract-plugin
export default {"MenuToggle":"MenuToggle_MenuToggle__uaDj1","open":"MenuToggle_open__2mfxw"};